import { useResizeObserver } from "@amzn/stencil-react-components/hooks";
import { Col, View } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { SearchResult } from "common/components";
import React, { FC, useLayoutEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { useSearchCatalogItems } from "./hook";

export * from "./reducer";

export interface CatalogItemsListProps {
  /**
   * Function to call to verify if should load more items
   */
  shouldLoadMore: () => boolean;

  /**
   * Function to call on the need to searh more items
   */
  onSearchNext: () => void;

  /**
   * Id of the container to view
   */
  scrollableTarget: string;
}

const CatalogItemsList: FC<CatalogItemsListProps> = (props) => {
  const { ref, height } = useResizeObserver<HTMLDivElement>();

  const { items, isLoading, isLoadingNextItems, totalCount } = useSearchCatalogItems();

  const hasMoreItems = () => {
    return items!.length < totalCount!;
  };

  // The InfiniteScroll needs the content to overflow to work, this useEffect forces the overflow if needed
  useLayoutEffect(() => {
    if (!hasMoreItems()) return;

    // Conditions is checking if should load more items
    if (props.shouldLoadMore()) {
      props.onSearchNext();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height, isLoadingNextItems, isLoading]);

  /* istanbul ignore next */
  const itemsComponents = items!.map((item) => (
    <SearchResult
      key={`${item.itemId}`}
      taxonomyId={item.itemId || ""}
      logo_url={item.logoImageUrl || ""}
      name={item.name || ""}
      short_description={item.shortDescription || ""}
      status={item.status || ""}
    />
  ));

  return (
    <Col ref={ref}>
      <InfiniteScroll
        next={props.onSearchNext}
        dataLength={itemsComponents.length}
        hasMore={hasMoreItems()}
        loader={
          <View padding="S700">
            <Spinner size={SpinnerSize.Medium} fr={undefined} />
          </View>
        }
        scrollableTarget={props.scrollableTarget}
      >
        {itemsComponents}
      </InfiniteScroll>
    </Col>
  );
};

export default CatalogItemsList;
